import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=452db9e8&scoped=true&"
import script from "./addGoods.vue?vue&type=script&lang=js&"
export * from "./addGoods.vue?vue&type=script&lang=js&"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=452db9e8&lang=scss&scoped=true&"
import style1 from "./addGoods.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452db9e8",
  null
  
)

component.options.__file = "addGoods.vue"
export default component.exports